import { render, staticRenderFns } from "./ListDetails.vue?vue&type=template&id=5a0da88d&scoped=true"
import script from "./ListDetails.vue?vue&type=script&lang=js"
export * from "./ListDetails.vue?vue&type=script&lang=js"
import style0 from "./ListDetails.vue?vue&type=style&index=0&id=5a0da88d&prod&scoped=true&lang=css"
import style1 from "./ListDetails.vue?vue&type=style&index=1&id=5a0da88d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0da88d",
  null
  
)

export default component.exports